import script from "./FlyingTiger-CampaignsV2.vue?vue&type=script&setup=true&lang=js"
export * from "./FlyingTiger-CampaignsV2.vue?vue&type=script&setup=true&lang=js"

import "./FlyingTiger-CampaignsV2.vue?vue&type=style&index=0&id=35b9fffb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35b9fffb"]])

export default __exports__